const Terms = () => (
  <div className="min-h-screen bg-background text-foreground">
    <div className="max-w-3xl mx-auto px-6 py-16">
      <h1 className="text-3xl font-bold mb-2">Terms of Service</h1>
      <p className="text-muted-foreground mb-8">Last updated: March 24, 2026</p>

      <div className="space-y-6 text-sm leading-relaxed">
        <section>
          <h2 className="text-lg font-semibold mb-2">1. Acceptance of Terms</h2>
          <p>By accessing or using Command X, you agree to be bound by these Terms of Service. If you do not agree to these terms, you may not use the platform.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">2. Description of Service</h2>
          <p>Command X is a construction project management and financial controls platform. The service includes project tracking, invoicing, billing, vendor management, document management, and integrations with third-party accounting software.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">3. Account Responsibilities</h2>
          <p>You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You must notify us immediately of any unauthorized use.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">4. Permitted Use</h2>
          <p>You may use Command X only for lawful business purposes. You may not reverse engineer, distribute, or create derivative works from the platform without written permission.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">5. Third-Party Integrations</h2>
          <p>Command X may integrate with third-party services (e.g., QuickBooks Online). Your use of those integrations is subject to the respective third party's terms of service. Command X is not responsible for the availability or accuracy of third-party services.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">6. Data Ownership</h2>
          <p>You retain ownership of all data you input into Command X. We do not claim ownership of your business data, documents, or financial records.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">7. Limitation of Liability</h2>
          <p>Command X is provided "as is" without warranties of any kind. To the maximum extent permitted by law, Command X shall not be liable for any indirect, incidental, or consequential damages arising from your use of the platform.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">8. Termination</h2>
          <p>We may suspend or terminate your access to Command X at any time for violation of these terms. You may cancel your account at any time through your account settings.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">9. Governing Law</h2>
          <p>These terms shall be governed by and construed in accordance with the laws of the State of Delaware, United States, without regard to conflict of law principles.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">10. Contact</h2>
          <p>For questions about these Terms, contact us at <span className="font-medium">legal@commandx.com</span>.</p>
        </section>
      </div>

      <div className="mt-12 pt-6 border-t border-border text-xs text-muted-foreground">
        © {new Date().getFullYear()} Command X. All rights reserved.
      </div>
    </div>
  </div>
);

export default Terms;
